/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
        (function() {

          "use strict";

          function toggleHandler(toggle) {
            toggle.addEventListener( "click", function(e) {
              e.preventDefault();
              (this.classList.contains("active") === true) ? this.classList.remove("active") : this.classList.add("active");
            });
          }
          
          var toggles = document.querySelectorAll(".cmn-toggle-switch");

          for (var i = toggles.length - 1; i >= 0; i--) {
            var toggle = toggles[i];
            toggleHandler(toggle);
          }

          function openPopup(){
            $('#wrapper-action').addClass('active');
          }

        })();

        $('.hamburger').click(function(){
            if(!$('.mobilemenu').hasClass('open')){
                $('.mobilemenu').addClass('open');
            }else{
                $('.mobilemenu').removeClass('open');
            }
        });

        $('#actionsubmit').on('click',function(){
          
          $.ajax({
            url: '/wp-content/themes/minicoolv3/sendmailchimp.php',
            method: 'POST',
            data: $('#actionform').serialize(),
            dataType: 'json',
            error: function(res){
              console.log(res);
              var result = JSON.parse(res);
              console.log(result);
            },
            success: function(res){
              if(res.status === 'KO'){
                alert(res.message);
              }else if(res.status === 'OK'){
                //DESCARGAR
                console.log('OK SUSCRIBED');
                var expiration = new Date();
                expiration.setTime(expiration.getTime() + (60000*60*24*365));
                setCookie("descarga","1",expiration);
                $('.wrapper-action').removeClass('active');
                alert("Thanks for suscribing, we'll send you an email to activate your subscription and download our free guide!");
              }
            }
          });
          return false;
        });

        
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
